import { defineNuxtPlugin, useHead, useRoute } from "#imports";


export default defineNuxtPlugin((nuxtApp) => {
	if (process.client) {
		const route = useRoute();
		const enabledRoutes = ['/lp/anima','/lp/fmu'];

		useHead(
			{
				script: [
					{
						hid: 'customer-io',
						children: `
						var _cio = _cio || [];
						(function() {
						  var a,b,c;a=function(f){return function(){_cio.push([f].
						  concat(Array.prototype.slice.call(arguments,0)))}};b=["load","identify",
						  "sidentify","track","page"];for(c=0;c<b.length;c++){_cio[b[c]]=a(b[c])};
						  var t = document.createElement('script'),
							  s = document.getElementsByTagName('script')[0];
						  t.async = true;
						  t.id    = 'cio-tracker';
						  t.setAttribute('data-site-id', 'bd9db220cf281bad11ef');
						  t.src = 'https://assets.customer.io/assets/track.js';
						  s.parentNode.insertBefore(t, s);
						})();
						`,
					}
				]
			}
		);
	}
});
